import React from "react";
import Heading from "../Heading";
import { classes } from "../utils/classes";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { sxClassName, sxProps, textAlignPropTypes } from "../props/sx";
import { spacingClassName, spacingProps } from "../props/spacing";
import { utilityClassName, utilityProps } from "../props/utility";

const HeroTitle = ({
	align,
	color,
	className = "",
	utility = { ...utilityProps },
	sx = { ...sxProps },
	spacing = { ...spacingProps },

	...props
}) => {
	return (
		<Heading
			Tag="h1"
			className={classes(
				"section-hero__title",
				...utilityClassName(utility),
				...sxClassName(deepMergeProps({ fontColor: color, textAlign: align }, pureProps(sx)), true),
				...spacingClassName(spacing),
				className,
			)}
			{...props}
		/>
	);
};

HeroTitle.propTypes = {
	align: textAlignPropTypes,
	...Heading.propTypes,
};

export default HeroTitle;
